import { StageType } from '@/store/types'
import type { V2WorkflowStagePayload } from '@/store/types/V2WorkflowStagePayload'

/** Distinct non-null `annotation_group_id` values from all Annotate and Model stages in a workflow. */
export const collectAnnotateAndModelStageAnnotationGroupIds = (
  stages: V2WorkflowStagePayload[],
): string[] => {
  const ids = new Set<string>()
  for (const stage of stages) {
    if (stage.type !== StageType.Annotate && stage.type !== StageType.Model) {
      continue
    }
    const groupId = stage.config.annotation_group_id
    if (groupId) {
      ids.add(groupId)
    }
  }
  return [...ids]
}
